import api from "src/apis/api"

export async function fetchLead(id) {
  const { data } = await api.get(`/api/v1/leads/${id}`)
  return data
}

export async function fetchLeadTimeline(id) {
  const { data } = await api.get(`/api/v1/leads/${id}/timeline`)
  return data.activities || []
}

export async function changeLeadStatus(id, status, note) {
  const { data } = await api.post(`/api/v1/leads/${id}/change_status`, { status, note })
  return data
}

export async function convertLeadToDeal(id, name) {
  const { data } = await api.post(`/api/v1/leads/${id}/convert_to_deal`, { name })
  return data
}

// Lead documents are now handled by the generic documents feature
// (src/features/documents/api/documentsApi.js) via the DocumentList component.
